export default __webpack_public_path__ + "static/media/Gender_Female.78c760fd.svg";